<template>
    <div>
        <app-sub-title text="Minutas" />
        <app-autocomplete
            class="mb-2"
            :items="clients"
            :get-object="false"
            v-model="clientId"
            label="Cliente"
        ></app-autocomplete>
        <!-- <app-clients-select-input
            v-model="clientId"
            :label="true"
            :placeholder="false"
            @change="onChangeClient"
        /> -->
        <app-clients-notebook-filters
            v-if="clientId"
            @filter="onFilter"
            @clean="resetFilters"
            @download="onDownload"
            :annotation-types="annotationTypes"
            :authors="authors"
        />
        <app-clients-notebook-list
            v-if="clientId"
            :data="notebook"
            :on-change-page="onChangePage"
            @sort="onSort"
            ref="noteList"
        />
        <b-alert variant="success" v-if="!clientId" show
            >Seleccione cliente</b-alert
        >
    </div>
</template>
<script>
import ClientsNotebookList from './ClientsNotebookList/ClientsNotebookList.vue'
import ClientsNotebookFilters from './ClientsNotebookFilters/ClientsNotebookFilters.vue'
import notebookRepository from '../../../repositories/notebook.repository.js'
import * as actionTypes from '../../../store/actionTypes'
import { mapGetters } from 'vuex'

export default {
    components: {
        appClientsNotebookList: ClientsNotebookList,
        appClientsNotebookFilters: ClientsNotebookFilters,
    },

    data() {
        return {
            clientId: '',
            notebookRaw: {},
            page: 1,
            // annotationTypes: '',
            authors: [],
            sort: {
                sortBy: 'created_at',
                sortDir: 'DESC',
            },
            term: '',
        }
    },
    computed: {
        ...mapGetters(['annotationTypes', 'clients']),
        notebook() {
            if (!this.notebookRaw || !this.notebookRaw.data) return {}

            if (!this.term) return this.notebookRaw

            const data = this.notebookRaw.data

            const searchMask = this.term
            const regEx = new RegExp(searchMask, 'ig')
            const replaceMask = `<span class="highlighted">${this.term.toUpperCase()}</span>`

            const newData = data.map(row => {
                let content = row.content.replace(regEx, replaceMask)
                return { ...row, content }
            })

            return { ...this.notebookRaw, data: newData }
        },
    },
    methods: {
        loadNotebookByClient() {
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
            }
            !!filters.term && (this.term = filters.term)
            const nr = Object.assign({}, notebookRepository)
            nr.getNotesByClient(this.clientId, this.page, filters)
                .then(data => {
                    this.notebookRaw = data
                })
                .catch(error => {
                    toastr.error(
                        `Error al cargar las minutas (${error.message})`
                    )
                })
        },
        loadAuthorsAnnotations() {
            if (!this.clientId) return
            const nr = Object.assign({}, notebookRepository)
            nr.getAuthorsAnnotations(this.clientId)
                .then(data => (this.authors = data))
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cargar los autores de las anotaciones'
                    )
                )
        },
        loadNotesAndAuthors() {
            this.loadNotebookByClient()
            this.loadAuthorsAnnotations()
        },
        onChangePage(page) {
            this.page = page
            this.loadNotebookByClient()
        },
        onFilter(filters) {
            this.page = 1
            this.filters = filters
            this.loadNotebookByClient()
        },
        resetFilters() {
            this.filters = {}
            this.loadNotebookByClient()
        },
        onChangeClient() {
            if (!!this.clientId) {
                this.loadNotesAndAuthors()
            } else {
                this.notebookRaw = {}
            }
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadNotebookByClient()
        },
        onDownload(filters) {
            const params = { ...filters, clientId: this.clientId }
            const queryString = _.toPairs(_.pickBy(params, _.identity))
                .map(item => item.join('='))
                .join('&')
            window.open(`exports/notebook?${queryString}`, '_blank')
        },
    },
    created() {
        this.load('annotationTypes')
        this.load('clients')
    },
}
</script>
